<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>Transfer Bookings</h2>
  <div class="flex gap-2">
    <button nz-button nzType="default" class="outline-button" (click)="openMultiplePagingBoard()">Create Paging Boards</button>
    <button
      *appHasAnyPrivilege="'TRANSFER_BOOKING_CREATE'"
      nz-button
      nzType="primary"
      (click)="navigateNewBooking()"
    >
      Add New Booking
    </button>
  </div>
</div>

<section id="transfer-records">
  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div
              class="flex flex-col sm:flex-row sm:justify-between sm:items-center md:items-end gap-4"
            >
              <div
                class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0"
              >
                <nz-input-group
                  nzSearch
                  [nzAddOnAfter]="suffixIconSearchButton"
                  style="width: auto"
                >
                  <input
                    type="text"
                    (keydown.enter)="search()"
                    [(ngModel)]="searchText"
                    nz-input
                    placeholder="Search here"
                  />
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button
                    nz-button
                    nzType="primary"
                    nzSearch
                    class="bg-[#6B6C6E] border-[#6B6C6E]"
                    (click)="search()"
                  >
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>

                <div
                  class="flex xl:w-auto flex-col lg:flex-row lg:items-center"
                >
                  <div class="">
                    <nz-form-label class="">Filter By Status</nz-form-label>
                  </div>

                  <div class="w-full">
                    <nz-select
                      [(ngModel)]="statusFilter"
                      (ngModelChange)="search()"
                      nzPlaceHolder="Select Status"
                      [nzAllowClear]="true"
                      class="w-full"
                    >
                      <nz-option
                        nzLabel="Reservation"
                        nzValue="RESERVATION"
                      ></nz-option>
                      <nz-option
                        nzLabel="On Transfer"
                        nzValue="ON_TRANSFER"
                      ></nz-option>
                      <nz-option
                        nzLabel="Completed"
                        nzValue="COMPLETED"
                      ></nz-option>
                      <nz-option
                        nzLabel="Cancelled"
                        nzValue="CANCELLED"
                      ></nz-option>
                    </nz-select>
                  </div>
                </div>
                <div>
                  <nz-divider class="hidden lg:block" [nzType]="'vertical'">
                  </nz-divider>
                </div>
                <nz-range-picker
                  [(ngModel)]="dateFilter"
                  (ngModelChange)="onChangeDateFilter($event)"
                ></nz-range-picker>
              </div>

              <div>
                <button
                  nz-button
                  nzBlock
                  class="outline-button"
                  (click)="resetSearch()"
                >
                  Reset All
                </button>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable
            [nzData]="bookingData"
            [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions"
            [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex"
            [nzFrontPagination]="false"
            [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)"
            nzTableLayout="fixed"
            [nzScroll]="{ x: 'auto', y: '550px' }"
            nzOuterBordered
            class="table-wSpace-nowrap"
          >
            <thead>
              <tr>
                <th>SR Tour ID</th>
                <th>Booking Category</th>
                <th>Status</th>
                <th>Agent</th>
                <th>Booking Ref No.</th>
                <th>Customer Name</th>
                <th>No. Of Pass</th>
                <th>Tour Date and Time</th>
                <th>Flight Number</th>
                <th>Pick Up Location</th>
                <th>Drop Off Location</th>
                <th>Vehicle Reg No.</th>
                <th>Driver Name</th>
                <th>
                  <span>Created Date</span>
                  <span
                    *ngIf="sortOrder === -1"
                    nz-icon
                    nzType="up"
                    nzTheme="outline"
                    class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    (click)="sort()"
                  >
                  </span>
                  <span
                    *ngIf="sortOrder === 1"
                    nz-icon
                    nzType="down"
                    nzTheme="outline"
                    class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    (click)="sort()"
                  >
                  </span>
                </th>
                <th
                  *appHasAnyPrivilege="
                    'TRANSFER_BOOKING_UPDATE,TRANSFER_BOOKING_SINGLE_VIEW'
                  "
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
                    <ng-container
                *ngFor="let data of basicTable.data"
                class="align-baseline"
              >
                <!--        Normal Repairs entry-->
                <tr *ngIf="(data.arrivalDetails?.status === statusFilter || statusFilter === null) || (((data.departureDetails?.status === statusFilter && data.bookingDetails.bookingCategory !== 'Arrival') || false) && !data.tourDetails.departureCheck)">
                  <td style="min-width: 100px;" [rowSpan]="haveArrivalAndDeparture(data) ? 2 : 1">
                    <a
                      *appHasAnyPrivilege="'TRANSFER_BOOKING_SINGLE_VIEW'"
                      class="clickable-text"
                      (click)="navigateToSingle(this.data._id)"
                      >{{ data.transferId ? data.transferId : "-" }}</a
                    >
                    <span
                      *ngIf="!hasPermission('TRANSFER_BOOKING_SINGLE_VIEW')"
                      >{{ data.transferId ? data.transferId : "-" }}</span
                    >
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="
                      (data.bookingDetails.bookingCategory === 'Arrival' &&
                        !data.tourDetails.departureCheck) ||
                      data.bookingDetails.bookingCategory === 'Departure'
                    "
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.bookingDetails
                        ? data.bookingDetails.bookingCategory
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="
                      data.bookingDetails.bookingCategory === 'Arrival' &&
                      data.tourDetails.departureCheck
                    "
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    Arrival
                  </td>
                  <td 
                  style="min-width: 150px;"
                  *ngIf="data.bookingDetails.bookingCategory === 'Departure'" [class.border-none-set]="haveArrivalAndDeparture(data)">
                    <nz-tag
                      *ngIf="data?.departureDetails.status === 'COMPLETED'"
                      [nzColor]="'#3ab200'"
                      class="rounded-full"
                      >Completed
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.departureDetails.status === 'CANCELLED'"
                      class="rounded-full"
                      [nzColor]="'#F3454C'"
                      >Cancelled
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.departureDetails.status === 'RESERVATION'"
                      [nzColor]="'#FF8C00'"
                      class="rounded-full"
                      >Reservation
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.departureDetails.status === 'ON_TRANSFER'"
                      [nzColor]="'#4655f5'"
                      class="rounded-full"
                      >On Transfer
                    </nz-tag>
                  </td>
                  <td 
                  style="min-width: 150px;"
                  *ngIf="data.bookingDetails.bookingCategory === 'Arrival'" [class.border-none-set]="haveArrivalAndDeparture(data)">
                    <nz-tag
                      *ngIf="data?.arrivalDetails.status === 'COMPLETED'"
                      [nzColor]="'#3ab200'"
                      class="rounded-full"
                      >Completed
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.arrivalDetails.status === 'CANCELLED'"
                      class="rounded-full"
                      [nzColor]="'#F3454C'"
                      >Cancelled
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.arrivalDetails.status === 'RESERVATION'"
                      [nzColor]="'#FF8C00'"
                      class="rounded-full"
                      >Reservation
                    </nz-tag>
                    <nz-tag
                      *ngIf="data?.arrivalDetails.status === 'ON_TRANSFER'"
                      [nzColor]="'#4655f5'"
                      class="rounded-full"
                      >On Transfer
                    </nz-tag>
                  </td>

                  <td 
                  style="min-width: 150px;"
                  [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.bookingDetails.agent
                        ? data.bookingDetails.agent.name
                        : "-"
                    }}
                  </td>
                  <td 
                  style="min-width: 150px;"
                  [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.bookingDetails.bookingReference
                        ? data.bookingDetails.bookingReference
                        : "-"
                    }}
                  </td>
                  <td 
                  style="min-width: 150px;"
                  [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails
                        ? data.tourDetails.customer?.renterDetails?.fullName
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails?.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.noOfPassengers
                        ? data.tourDetails.noOfPassengers
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.departureTourDetails
                        .departureNoOfPassengers
                        ? data.tourDetails.departureTourDetails
                            .departureNoOfPassengers
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.arrivalFlightDate
                        ? (data.tourDetails.arrivalFlightDate
                            | date: "yyyy-MM-dd") +
                          " | " +
                          (data.tourDetails.pickUpTime | date: "hh:mm a")
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails?.departureTourDetails?.departureFlightDate
                        ? (data.tourDetails?.departureTourDetails
                            .departureFlightDate | date: "yyyy-MM-dd") +
                          " | " +
                          (data.tourDetails.departureTourDetails
                            .departurePickUpTime | date: "hh:mm a")
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.arrivalFlightNumber
                        ? data.tourDetails.arrivalFlightNumber
                        : "-"
                    }}
                  </td>
                  <td
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.departureTourDetails
                        .departureFlightNumber
                        ? data.tourDetails.departureTourDetails
                            .departureFlightNumber
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.pickUpLocation
                        ? data.tourDetails.pickUpLocation
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.departureTourDetails
                        .departurePickUpLocation
                        ? data.tourDetails.departureTourDetails
                            .departurePickUpLocation
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.dropOffLocation
                        ? data.tourDetails.dropOffLocation
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.tourDetails.departureTourDetails
                        .departureDropOffLocation
                        ? data.tourDetails.departureTourDetails
                            .departureDropOffLocation
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.arrivalDetails?.allocatedVehicle?.vehicleDetails
                        ?.registrationNumber || "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.departureDetails?.allocatedVehicle?.vehicleDetails
                        ?.registrationNumber || "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory !== 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.arrivalDetails.allocateDriver
                        ? data.arrivalDetails.allocateDriver.fullName
                        : "-"
                    }}
                  </td>
                  <td
                  style="min-width: 150px;"
                    *ngIf="data.bookingDetails.bookingCategory === 'Departure'"
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    {{
                      data.departureDetails.allocateDriver
                        ? data.departureDetails.allocateDriver.fullName
                        : "-"
                    }}
                  </td>
                  <td 
                  style="min-width: 150px;"
                  [class.border-none-set]="haveArrivalAndDeparture(data)">{{ data?.createdAt | date: "dd-MM-y" }}</td>
                  <td
                  style="min-width: 150px;"
                    *appHasAnyPrivilege="
                      'TRANSFER_BOOKING_UPDATE,TRANSFER_BOOKING_SINGLE_VIEW'
                    "
                    [class.border-none-set]="haveArrivalAndDeparture(data)">
                    <button
                      *appHasAnyPrivilege="'TRANSFER_BOOKING_UPDATE'"
                      class="mr-3"
                      nz-button
                      nzType="default"
                      [class.outline-button]="!editBtnDisableCheck(data)"
                      [disabled]="editBtnDisableCheck(data)"
                      (click)="editNavigate(this.data._id)"
                    >
                      Edit
                    </button>
                    <button
                      *appHasAnyPrivilege="
                        'TRANSFER_BOOKING_UPDATE,TRANSFER_BOOKING_SINGLE_VIEW'
                      "
                      class="outline-button more-dropdown"
                      nz-button
                      nz-dropdown
                      [nzDropdownMenu]="menu"
                      nzPlacement="bottomCenter"
                    >
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li
                          *appHasAnyPrivilege="'TRANSFER_BOOKING_SINGLE_VIEW'"
                          nz-menu-item
                          nz-popconfirm
                          nz-button
                          (click)="navigateToSingle(data._id)"
                        >
                          View
                        </li>
                        <span *ngIf="(data.bookingDetails.bookingCategory === 'Arrival' && data?.arrivalDetails.status !== 'COMPLETED') || (data.bookingDetails.bookingCategory === 'Departure' && data?.departureDetails.status !== 'COMPLETED')">
                        <li
                          *appHasAnyPrivilege="'TRANSFER_BOOKING_CHANGE_STATUS'"
                          nz-submenu
                          nzTitle="Change Status"
                        >
                          <ul>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="

                                data?.arrivalDetails.status === 'CANCELLED'
                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'RESERVATION',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Reservation
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="

                                data?.departureDetails.status === 'CANCELLED' && data.tourDetails.departureCheck === false
                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'RESERVATION',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Reservation
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                data?.arrivalDetails.status === 'RESERVATION'

                              "
                              nzPopconfirmTitle="Are you sure you want change the status to On Transfer"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'ON_TRANSFER',
                                  data,
                                  'single'
                                )
                              "
                            >
                              OnTransfer
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                data?.departureDetails.status === 'RESERVATION' && data.tourDetails.departureCheck === false

                              "
                              nzPopconfirmTitle="Are you sure you want change the status to On Transfer"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'ON_TRANSFER',
                                  data,
                                  'single'
                                )
                              "
                            >
                              OnTransfer
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                data?.arrivalDetails.status === 'ON_TRANSFER'

                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Completed?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'COMPLETED',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Completed
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                data?.departureDetails.status === 'ON_TRANSFER' && data.tourDetails.departureCheck === false

                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Completed?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'COMPLETED',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Completed
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                data?.arrivalDetails.status === 'RESERVATION' ||

                                data?.arrivalDetails.status === 'ON_TRANSFER'
                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'CANCELLED',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Cancelled
                            </li>
                            <li
                              nz-menu-item
                              nz-popconfirm
                              *ngIf="
                                (data?.departureDetails.status === 'RESERVATION' ||

                                data?.departureDetails.status === 'ON_TRANSFER') && data.tourDetails.departureCheck === false
                              "
                              nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
                              [nzOkText]="'Yes'"
                              [nzCancelText]="'No'"
                              (nzOnCancel)="handleCancelSelectStatus()"
                              (nzOnConfirm)="
                                handleOkSelectStatus(
                                  'CANCELLED',
                                  data,
                                  'single'
                                )
                              "
                            >
                              Cancelled
                            </li>

                          </ul>
                        </li>
                        </span>
                      </ul>
                    </nz-dropdown-menu>
                  </td>
                </tr>

                <ng-container *ngIf="haveArrivalAndDeparture(data)">
                  <tr class="additional-row" >
<!--                    <td>-->
<!--                      <a-->
<!--                        *appHasAnyPrivilege="'TRANSFER_BOOKING_SINGLE_VIEW'"-->
<!--                        class="clickable-text"-->
<!--                        (click)="navigateToSingle(data._id)"-->
<!--                        >{{ data.transferId ? data.transferId : "-" }}</a-->
<!--                      >-->
<!--                      <span-->
<!--                        *ngIf="!hasPermission('TRANSFER_BOOKING_SINGLE_VIEW')"-->
<!--                        >{{ data.transferId ? data.transferId : "-" }}</span-->
<!--                      >-->
<!--                    </td>-->
                    <td>Departure</td>
                    <td>
                      <nz-tag
                        *ngIf="data?.departureDetails.status === 'COMPLETED'"
                        [nzColor]="'#3ab200'"
                        class="rounded-full"
                        >Completed
                      </nz-tag>
                      <nz-tag
                        *ngIf="data?.departureDetails.status === 'CANCELLED'"
                        class="rounded-full"
                        [nzColor]="'#F3454C'"
                        >Cancelled
                      </nz-tag>
                      <nz-tag
                        *ngIf="data?.departureDetails.status === 'RESERVATION'"
                        [nzColor]="'#FF8C00'"
                        class="rounded-full"
                        >Reservation
                      </nz-tag>
                      <nz-tag
                        *ngIf="data?.departureDetails.status === 'ON_TRANSFER'"
                        [nzColor]="'#4655f5'"
                        class="rounded-full"
                        >On Transfer
                      </nz-tag>
                    </td>
                    <td>
                      {{
                        data.bookingDetails.agent
                          ? data.bookingDetails.agent.name
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.bookingDetails.bookingReference
                          ? data.bookingDetails.bookingReference
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails
                          ? data.tourDetails?.customer?.renterDetails?.fullName
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails.departureTourDetails
                          .departureNoOfPassengers
                          ? data.tourDetails.departureTourDetails
                              .departureNoOfPassengers
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails.departureTourDetails
                          .departureFlightDate
                          ? (data.tourDetails.departureTourDetails
                              .departureFlightDate | date: "yyyy-MM-dd") +
                            " | " +
                            (data.tourDetails.departureTourDetails
                              .departurePickUpTime | date: "hh:mm a")
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails.departureTourDetails
                          .departureFlightNumber
                          ? data.tourDetails.departureTourDetails
                              .departureFlightNumber
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails.departureTourDetails
                          .departurePickUpLocation
                          ? data.tourDetails.departureTourDetails
                              .departurePickUpLocation
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.tourDetails.departureTourDetails
                          .departureDropOffLocation
                          ? data.tourDetails.departureTourDetails
                              .departureDropOffLocation
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.departureDetails?.allocatedVehicle?.vehicleDetails
                          ?.registrationNumber || "-"
                      }}
                    </td>
                    <td>
                      {{
                        data.departureDetails.allocateDriver
                          ? data.departureDetails.allocateDriver.fullName
                          : "-"
                      }}
                    </td>
                    <td>{{ data?.createdAt | date: "dd-MM-y" }}</td>
                    <td
                      *appHasAnyPrivilege="
                        'TRANSFER_BOOKING_UPDATE,TRANSFER_BOOKING_SINGLE_VIEW'
                      "
                    >
                      <button
                        *appHasAnyPrivilege="'TRANSFER_BOOKING_UPDATE'"
                        class="mr-3"
                        nz-button
                        nzType="default"
                        [class.outline-button]="!editBtnDisableCheckAdditional(data)"
                        [disabled]="editBtnDisableCheckAdditional(data)"
                        (click)="editNavigate(this.data._id)"
                      >
                        Edit
                      </button>

                      <button
                        *appHasAnyPrivilege="
                          'TRANSFER_BOOKING_UPDATE,TRANSFER_BOOKING_SINGLE_VIEW'
                        "
                        class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter"
                      >
                        <span nz-icon nzType="more" nzTheme="outline"></span>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <li
                            *appHasAnyPrivilege="'TRANSFER_BOOKING_SINGLE_VIEW'"
                            nz-menu-item
                            nz-popconfirm
                            nz-button
                            (click)="navigateToSingle(data._id)"
                          >
                            View
                          </li>
                          <span *ngIf="data?.departureDetails.status !== 'COMPLETED'">
                            <li
                              *appHasAnyPrivilege="'TRANSFER_BOOKING_UPDATE'"
                              nz-submenu
                              nzTitle="Change Status"
                            >
                            <ul>
                              <li
                                nz-menu-item
                                nz-popconfirm
                                *ngIf="
                                data?.departureDetails.status === 'CANCELLED'

                              "
                                nzPopconfirmTitle="Are you sure you want change the status to Reservation?"
                                [nzOkText]="'Yes'"
                                [nzCancelText]="'No'"
                                (nzOnCancel)="handleCancelSelectStatus()"
                                (nzOnConfirm)="
                                  handleOkSelectStatus(
                                    'RESERVATION',
                                    data,
                                    'both'
                                  )
                                "
                              >
                                Reservation
                              </li>
                              <li
                                nz-menu-item
                                nz-popconfirm
                                *ngIf="
                                data?.departureDetails.status === 'RESERVATION'

                              "
                                nzPopconfirmTitle="Are you sure you want change the status to On Transfer"
                                [nzOkText]="'Yes'"
                                [nzCancelText]="'No'"
                                (nzOnCancel)="handleCancelSelectStatus()"
                                (nzOnConfirm)="
                                  handleOkSelectStatus(
                                    'ON_TRANSFER',
                                    data,
                                    'both'
                                  )
                                "
                              >
                                OnTransfer
                              </li>
                              <li
                                nz-menu-item
                                nz-popconfirm
                                *ngIf="
                                data?.departureDetails.status === 'ON_TRANSFER'

                              "
                                nzPopconfirmTitle="Are you sure you want change the status to Completed?"
                                [nzOkText]="'Yes'"
                                [nzCancelText]="'No'"
                                (nzOnCancel)="handleCancelSelectStatus()"
                                (nzOnConfirm)="
                                  handleOkSelectStatus(
                                    'COMPLETED',
                                    data,
                                    'both'
                                  )
                                "
                              >
                                Completed
                              </li>
                              <li
                                nz-menu-item
                                nz-popconfirm
                                *ngIf="
                                data?.departureDetails.status === 'ON_TRANSFER' ||  data?.departureDetails.status === 'RESERVATION'

                              "
                                nzPopconfirmTitle="Are you sure you want change the status to Cancelled?"
                                [nzOkText]="'Yes'"
                                [nzCancelText]="'No'"
                                (nzOnCancel)="handleCancelSelectStatus()"
                                (nzOnConfirm)="
                                  handleOkSelectStatus(
                                    'CANCELLED',
                                    data,
                                    'both'
                                  )
                                "
                              >
                                Cancelled
                              </li>
                            </ul>
                          </li>
                          </span>
                        </ul>
                      </nz-dropdown-menu>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template
          [columnData]="skeletonTableColumns"
        ></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>
</section>
<app-multiple-paging-board-popup [isVisible]="openMultiplePagingBoardPopup" [tourType]="'TRANSFER'" (multiplePagingBoardOnChange)="onGetMultiplePagingBoardChange($event)"></app-multiple-paging-board-popup>


<nz-modal
  [(nzVisible)]="isVisibleFuelAndMileageUpdate"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
>
  <ng-template #modalTitle>{{
    changingStatus === "CANCELLED"
      ? "Reason for Cancellation"
      : "Current Fuel and Mileage
    Update"
  }}</ng-template>

  <ng-template #modalContent>
    <div
      *ngIf="changingStatus === 'ON_TRANSFER' || changingStatus === 'COMPLETED'"
      class="flex flex-col gap-4"
    >
      <p class="font-bold">
        {{ changingStatus === "ON_TRANSFER" ? "Start" : "End" }} Mileage :
      </p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" class="w-full"
               [(ngModel)]="mileage" [step]="1"
               placeholder="Enter Mileage" />
      </nz-input-group>

      <p class="font-bold">
        {{ changingStatus === "ON_TRANSFER" ? "Start" : "End" }} Fuel Level :
      </p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" class="w-full"
               [(ngModel)]="fuelLevel"
               placeholder="Enter Fuel Level" />
      </nz-input-group>
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select
        class="w-full"
        [(ngModel)]="cancelReason"
        nzPlaceHolder="Select Preference"
        nzShowSearch
        nzAllowClear
        [nzDropdownRender]="renderTemplate"
      >
        <nz-option
          *ngFor="let item of cancelReasonOptions"
          [nzLabel]="item"
          [nzValue]="item"
        ></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement />
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button
      nz-button
      nzType="default"
      (click)="handleCancelUpdateFuelAndMileage()"
    >
      Cancel
    </button>
    <button
      *ngIf="!(changingStatus === 'CANCELLED')"
      nz-button
      nzType="primary"
      [disabled]="fuelLevel === 0 || undefined || mileage === 0 || undefined"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
      [nzOkText]="'Yes'"
      [nzCancelText]="'No'"
      (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
      (nzOnConfirm)="handleOkUpdateFuelAndMileage()"
      [nzLoading]="isLoading"
    >
      Save
    </button>
    <button
      *ngIf="changingStatus === 'CANCELLED'"
      nz-button
      nzType="primary"
      [disabled]="cancelReason === null"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
      [nzOkText]="'Yes'"
      [nzCancelText]="'No'"
      (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
      (nzOnConfirm)="handleOkCancelledStatus()"
      [nzLoading]="isLoading"
    >
      Save
    </button>
  </ng-template>
</nz-modal>
